import axios from 'axios';

let _endpoint: string = "https://jllt989f7l.execute-api.us-west-2.amazonaws.com/Prod/";
//let _endpoint: string = "https://dtgr565vaj.execute-api.us-west-2.amazonaws.com/Prod/";
let _token: () => string;

export const getEndpoint = (path: string, replacements: any | null) => {
    // if (!_endpoint) {
    //     _endpoint = getAppConfig().ApiUrl;
    // }

    if (replacements) {
        for (var prop in replacements) {
            path = path.replace('{' + prop + '}', replacements[prop]);
        }
    }

    return _endpoint + path;
}

export const setToken = (fetchToken: () => string) => {
    _token = fetchToken;
}

export const getRequestHeaders = (secure: boolean = false) => {
    if (secure) {
        return {
            headers: {
                'Authorization': "bearer " + _token(),
                'Accept': "application/json"
            }
        };
    } else {
        return {
            headers: {
                'Accept': "application/json"
            }
        };
    }
}

export const getRequest = (path: string, replacements: any | null) => {
    return new Promise((resolve, reject) => {
        axios
            .get(
                getEndpoint(path, replacements),
                getRequestHeaders(true)
            )
            .then(function (response) {
                resolve(response.data);
            })
            .catch(function (rs) {
                reject(rs);
            });
    });
}

export const postRequest = (path: string, replacements: any | null, payload: any) => {
    return new Promise((resolve, reject) => {
        axios
            .post(
                getEndpoint(path, replacements),
                payload,
                getRequestHeaders(true)
            )
            .then(function (response) {
                resolve(response.data);
            })
            .catch(function (rs) {
                reject(rs);
            });
    });
}

export const putRequest = (path: string, replacements: any | null, payload: any) => {
    return new Promise((resolve, reject) => {
        axios
            .put(
                getEndpoint(path, replacements),
                payload,
                getRequestHeaders(true)
            )
            .then(function (response) {
                resolve(response.data);
            })
            .catch(function (rs) {
                reject(rs);
            });
    });
}

export const deleteRequest = (path: string, replacements: any | null) => {
    return new Promise((resolve, reject) => {
        axios
            .delete(
                getEndpoint(path, replacements),
                getRequestHeaders(true)
            )
            .then(function (response) {
                resolve(response.data);
            })
            .catch(function (rs) {
                reject(rs);
            });
    });
}